import React from "react";

const Calendar = () => {
  return (
    <div className="calendar-container">
      <header className="calendar-header">
        <h1 className="calendar-h1">University of Nepal</h1>
        <h2 className="calendar-h2">Master of Public Policy</h2>
        <h3 className="calendar-h3">Academic Calendar, 2083 (2026/2027)</h3>
      </header>

      <span className="semester-label">First Semester</span>

      <section className="month-section">
        <div className="month-title">Baishakh, 2083 || April/May 2026</div>
        <table className="calendar-table">
          <tr>
            <td className="day-col">Wednesday</td>
            <td className="date-col">12 (April 22)</td>
            <td className="event-col">
              Orientation program for the new students
            </td>
          </tr>
          <tr>
            <td>Monday</td>
            <td>14 (April 27)</td>
            <td>First semester classes begin</td>
          </tr>
        </table>
      </section>

      <section className="month-section">
        <div className="month-title">Jestha, 2083 || May/June 2026</div>
        <table className="calendar-table">
          <tr>
            <td className="day-col">Friday</td>
            <td className="date-col">1 (May 15)</td>
            <td className="event-col">PDR Seminar</td>
          </tr>
          <tr>
            <td>Friday</td>
            <td>15 (May 29)</td>
            <td>PDR Seminar</td>
          </tr>
          <tr>
            <td>Friday</td>
            <td>29 (June 12)</td>
            <td>PDR Seminar</td>
          </tr>
        </table>
      </section>

      <section className="month-section">
        <div className="month-title">Ashad, 2083 || June/July 2026</div>
        <table className="calendar-table">
          <tr>
            <td className="day-col">Friday</td>
            <td className="date-col">5 (June 19)</td>
            <td className="event-col">PDR Seminar</td>
          </tr>
          <tr>
            <td>Monday - Friday</td>
            <td>8-12 (June 22-26)</td>
            <td>Mid-Term Exam Week || Submission/Presentation</td>
          </tr>
          <tr>
            <td>Friday</td>
            <td>19 (July 3)</td>
            <td>PDR Seminar</td>
          </tr>
        </table>
      </section>

      <section className="month-section">
        <div className="month-title">Shrawan, 2083 || July/August 2026</div>
        <table className="calendar-table">
          <tr>
            <td className="day-col">Friday</td>
            <td className="date-col">1 (July 17)</td>
            <td className="event-col">PDR Seminar</td>
          </tr>
          <tr>
            <td>Friday</td>
            <td>15 (July 31)</td>
            <td>PDR Seminar</td>
          </tr>
          <tr>
            <td>Friday</td>
            <td>29 (August 14)</td>
            <td>PDR Seminar</td>
          </tr>
        </table>
      </section>

      <section className="month-section">
        <div className="month-title">Bhadra, 2083 || August/September 2026</div>
        <table className="calendar-table">
          <tr>
            <td className="day-col">Monday - Friday</td>
            <td className="date-col">1 – 5 (August 17-21)</td>
            <td className="event-col">Final Exam Week</td>
          </tr>
          <tr>
            <td>Friday</td>
            <td>5 (August 21)</td>
            <td>Last day of the semester</td>
          </tr>
        </table>
      </section>

      <span className="semester-label">Second Semester</span>

      <section className="month-section">
        <div className="month-title">Asoj, 2083 || September/October 2026</div>
        <table className="calendar-table">
          <tr>
            <td className="day-col">Monday</td>
            <td className="date-col">5 (Sept 21)</td>
            <td className="event-col">Second Semester classes begin</td>
          </tr>
          <tr>
            <td>Friday</td>
            <td>23 (Sept 9)</td>
            <td>PDR Seminar</td>
          </tr>
          <tr>
            <td>Monday - Friday</td>
            <td>25-31 (Oct 11-17)</td>
            <td>Dashain Holiday</td>
          </tr>
        </table>
      </section>

      <section className="month-section">
        <div className="month-title">Kartik, 2083 || October/November 2026</div>
        <table className="calendar-table">
          <tr>
            <td className="day-col">Monday - Saturday</td>
            <td className="date-col">1-6 (Oct 19-23)</td>
            <td className="event-col">Dashain holiday</td>
          </tr>
          <tr>
            <td>Friday</td>
            <td>20 (November 6)</td>
            <td>PDR Seminar</td>
          </tr>
          <tr>
            <td>Saturday - Friday</td>
            <td>22-27 (Nov 8-13)</td>
            <td>Tihar holiday</td>
          </tr>
        </table>
      </section>

      <section className="month-section">
        <div className="month-title">
          Mangsir, 2083 || November/December 2026
        </div>
        <table className="calendar-table">
          <tr>
            <td className="day-col">Friday</td>
            <td className="date-col">11 (Nov 27)</td>
            <td className="event-col">PDR Seminar</td>
          </tr>
          <tr>
            <td>Monday - Friday</td>
            <td>21-25 (Dec 7 - 11)</td>
            <td>Mid-term exam week</td>
          </tr>
        </table>
      </section>

      <section className="month-section">
        <div className="month-title">Poush, 2083 || December/January 2027</div>
        <table className="calendar-table">
          <tr>
            <td className="day-col">Friday</td>
            <td className="date-col">4 (Dec 18)</td>
            <td className="event-col">PDR Seminar</td>
          </tr>
          <tr>
            <td>Friday</td>
            <td>10 (Dec 25)</td>
            <td>Christmas holiday</td>
          </tr>
          <tr>
            <td>Friday</td>
            <td>17 (Jan 1)</td>
            <td>PDR Seminar</td>
          </tr>
          <tr>
            <td>Monday</td>
            <td>27 (Jan 11)</td>
            <td>Prithibi Jayanti</td>
          </tr>
        </table>
      </section>

      <section className="month-section">
        <div className="month-title">Magh, 2083 || January/February 2027</div>
        <table className="calendar-table">
          <tr>
            <td className="day-col">Friday</td>
            <td className="date-col">1 (Jan 15)</td>
            <td className="event-col">Maghi Parba holiday</td>
          </tr>
          <tr>
            <td>Friday</td>
            <td>22 (Jan 22)</td>
            <td>PDR Seminar</td>
          </tr>
          <tr>
            <td>Friday</td>
            <td>18 - 22 (Feb 1-5)</td>
            <td>Final exam week</td>
          </tr>
          <tr>
            <td>Friday</td>
            <td>22 (February 5)</td>
            <td>Last day of the semester</td>
          </tr>
        </table>
      </section>
    </div>
  );
};

export default Calendar;
